(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snaiferr-about"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-snaiferr-about]');
    if (!roots.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const headerOffset = function () {
      const headerSection = document.querySelector('.header-section');
      if (headerSection) {
        const height = Math.round(headerSection.getBoundingClientRect().height);
        if (height > 0) return height + 12;
      }
      return 72;
    };

    roots.forEach(function (root) {
      root.classList.add('js-ready');
      root.style.setProperty('--snaiferr-about-header-offset', headerOffset() + 'px');

      const progress = root.querySelector('[data-about-progress]');
      const reveals = root.querySelectorAll('[data-reveal]');
      const parallax = root.querySelectorAll('[data-parallax]');

      if (!reduced && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) entry.target.classList.add('is-inview');
            });
          },
          { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
        );
        reveals.forEach(function (el) {
          io.observe(el);
        });
      } else {
        reveals.forEach(function (el) {
          el.classList.add('is-inview');
        });
      }

      const onScroll = function () {
        const rect = root.getBoundingClientRect();
        const total = Math.max(root.offsetHeight - window.innerHeight, 1);
        const passed = Math.min(Math.max(-rect.top, 0), total);
        if (progress) progress.style.width = (passed / total) * 100 + '%';

        if (!reduced) {
          parallax.forEach(function (el) {
            const top = el.getBoundingClientRect().top;
            const shift = Math.max(Math.min((top - 180) * -0.06, 28), -28);
            el.style.transform = 'translate3d(0,' + shift + 'px,0)';
          });
        }
      };

      let ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            onScroll();
            ticking = false;
          });
        },
        { passive: true }
      );
      window.addEventListener('resize', function () {
        root.style.setProperty('--snaiferr-about-header-offset', headerOffset() + 'px');
        onScroll();
      });
      onScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snaiferr-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-snaiferr-faq]');
    if (!roots.length) return;

    const headerOffset = function () {
      const headerSection = document.querySelector('.header-section');
      if (headerSection) {
        const height = Math.round(headerSection.getBoundingClientRect().height);
        if (height > 0) return height + 12;
      }
      const value = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
      return Number.isFinite(value) && value > 0 ? value + 12 : 72;
    };

    const applyOffset = function (root) {
      root.style.setProperty('--snaiferr-faq-header-offset', headerOffset() + 'px');
    };

    const scrollToGroup = function (group) {
      if (!group) return;
      group.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    roots.forEach(function (root) {
      applyOffset(root);
      window.addEventListener('resize', function () {
        applyOffset(root);
      });

      const links = Array.from(root.querySelectorAll('[data-faq-nav]'));
      const groups = Array.from(root.querySelectorAll('[data-faq-group]'));
      const select = root.querySelector('[data-faq-select]');
      if (!groups.length) return;

      const setActive = function (id) {
        links.forEach(function (link) {
          const on = link.getAttribute('data-faq-nav') === id;
          link.classList.toggle('is-active', on);
          if (on) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
        if (select && select.value !== id) select.value = id;
      };

      const syncActive = function () {
        const probe = headerOffset();
        let current = groups[0];
        groups.forEach(function (group) {
          if (group.getBoundingClientRect().top <= probe + 8) current = group;
        });
        if (current) setActive(current.id);
      };

      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          const id = link.getAttribute('data-faq-nav');
          const group = root.querySelector('#' + CSS.escape(id));
          if (!group) return;
          event.preventDefault();
          if (history.replaceState) {
            history.replaceState(null, '', '#' + id);
          }
          setActive(id);
          scrollToGroup(group);
        });
      });

      if (select) {
        select.addEventListener('change', function () {
          const group = root.querySelector('#' + CSS.escape(select.value));
          if (!group) return;
          if (history.replaceState) {
            history.replaceState(null, '', '#' + select.value);
          }
          setActive(select.value);
          scrollToGroup(group);
        });
      }

      let ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            syncActive();
            ticking = false;
          });
        },
        { passive: true }
      );

      if (location.hash) {
        const initial = root.querySelector(location.hash);
        if (initial && initial.hasAttribute('data-faq-group')) {
          setActive(initial.id);
          window.requestAnimationFrame(function () {
            scrollToGroup(initial);
          });
        } else {
          syncActive();
        }
      } else {
        syncActive();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snaiferr-legal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-snaiferr-legal]');
    if (!roots.length) return;

    const headerOffset = function () {
      const headerSection = document.querySelector('.header-section');
      if (headerSection) {
        const height = Math.round(headerSection.getBoundingClientRect().height);
        if (height > 0) return height + 12;
      }
      const value = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height'));
      return Number.isFinite(value) && value > 0 ? value + 12 : 72;
    };

    const pad = function (index) {
      return index < 10 ? '0' + index : String(index);
    };

    const slug = function (text, index) {
      const base = (text || 'sezione')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 48);
      return (base || 'sezione') + '-' + index;
    };

    const hideRefundLetterhead = function (root, body) {
      if (root.getAttribute('data-policy-key') !== 'refund-policy') return;
      const els = Array.from(body.children);
      if (els.length < 3) return;
      const title = els[0];
      const line = els[1];
      const rule = els[2];
      if (!title || title.tagName !== 'H1') return;
      const titleText = title.textContent.replace(/\s+/g, ' ').trim();
      if (titleText !== 'Consegne, Diritto di Recesso e Resi') return;
      if (!line || line.tagName !== 'P') return;
      const lineText = line.textContent.replace(/\s+/g, ' ').trim();
      if (!/Snaiferr Shop di Lorenzo Guastaferro/i.test(lineText)) return;
      if (!/Via Zurlo/i.test(lineText)) return;
      if (/recesso|rimbors|art\.|giorni|prodotto|cliente/i.test(lineText)) return;
      if (!rule || rule.tagName !== 'HR') return;
      [title, line, rule].forEach(function (el) {
        el.classList.add('snaiferr-legal__letterhead');
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
      });
    };

    const hideEmptyNodes = function (body) {
      Array.from(body.children).forEach(function (el) {
        const text = el.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
        if (text === '') {
          el.classList.add('snaiferr-legal__empty');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const markOfficialSectionTitles = function (body) {
      const pattern = /^(PANORAMICA|SEZIONE\s+\d+(\s*[-–—].*)?)$/i;
      Array.from(body.querySelectorAll('strong')).forEach(function (el) {
        const text = el.textContent.replace(/\s+/g, ' ').trim();
        if (!pattern.test(text) || text.length > 90) return;
        el.classList.add('snaiferr-legal__inline-heading');
      });
    };

    const markLegalNoticeSections = function (root, body) {
      if (root.getAttribute('data-policy-key') !== 'legal-notice') return;
      if (body.querySelector('.snaiferr-legal__inline-heading, h2, h3')) return;

      const topics = [
        { test: /termini e condizioni del servizio/i, title: 'Termini e condizioni del servizio' },
        { test: /contenuti presenti sul nostro sito|propriet[aà] esclusiva/i, title: 'Proprietà dei contenuti' },
        { test: /non siamo responsabili/i, title: 'Limitazione di responsabilità' },
        { test: /controversie o reclami/i, title: 'Controversie e reclami' },
        { test: /legge italiana|foro competente/i, title: 'Legge applicabile' },
        { test: /modificare questa informativa legale/i, title: 'Modifiche' },
        { test: /contattarci tramite il nostro servizio clienti/i, title: 'Contatti' }
      ];

      Array.from(body.querySelectorAll('p')).forEach(function (paragraph) {
        const text = paragraph.textContent.replace(/\s+/g, ' ').trim();
        if (!text) return;
        const topic = topics.find(function (item) {
          return item.test.test(text);
        });
        if (!topic) return;
        topic.test = /$never^/;
        const heading = document.createElement('h2');
        heading.className = 'snaiferr-legal__inline-heading';
        heading.textContent = topic.title;
        paragraph.parentNode.insertBefore(heading, paragraph);
      });
    };

    const markPrivacySectionTitles = function (root, body) {
      if (root.getAttribute('data-policy-key') !== 'privacy-policy') return;
      Array.from(body.querySelectorAll('div > span')).forEach(function (span) {
        const parent = span.parentElement;
        if (!parent || parent.children.length !== 1) return;
        if (span.querySelector('a, strong, em, br')) return;
        const text = span.textContent.replace(/\s+/g, ' ').trim();
        if (!text) return;
        if (/^ultimo aggiornamento/i.test(text)) {
          span.classList.add('snaiferr-legal__updated');
          return;
        }
        if (text.length < 3 || text.length > 80) return;
        if (/[.:;,]$/.test(text)) return;
        span.classList.add('snaiferr-legal__inline-heading');
        span.setAttribute('role', 'heading');
        span.setAttribute('aria-level', '2');
      });
    };

    const navLabel = function (text) {
      return text.replace(/^SEZIONE\s+\d+\s*[-–—]\s*/i, '').trim() || text;
    };

    roots.forEach(function (root) {
      root.style.setProperty('--snaiferr-legal-header-offset', headerOffset() + 'px');
      window.addEventListener('resize', function () {
        root.style.setProperty('--snaiferr-legal-header-offset', headerOffset() + 'px');
      });

      const body = root.querySelector('[data-legal-body]');
      const nav = root.querySelector('[data-legal-nav]');
      const list = root.querySelector('[data-legal-nav-list]');
      const select = root.querySelector('[data-legal-select]');
      const layout = root.querySelector('[data-legal-layout]');
      if (!body || !nav || !list || !layout) return;

      hideRefundLetterhead(root, body);
      hideEmptyNodes(body);
      markOfficialSectionTitles(body);
      markPrivacySectionTitles(root, body);
      markLegalNoticeSections(root, body);

      const headings = Array.from(body.querySelectorAll('h2, h3, .snaiferr-legal__inline-heading')).filter(function (heading) {
        if (heading.classList.contains('snaiferr-legal__letterhead')) return false;
        return heading.textContent.trim().length > 0;
      });

      if (headings.length < 2) {
        nav.hidden = true;
        layout.classList.add('snaiferr-legal__layout--single');
        return;
      }

      nav.hidden = false;
      layout.classList.remove('snaiferr-legal__layout--single');

      const links = [];
      headings.forEach(function (heading, index) {
        if (!heading.id) heading.id = slug(heading.textContent, index + 1);
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'snaiferr-legal__nav-link' + (index === 0 ? ' is-active' : '');
        link.href = '#' + heading.id;
        link.setAttribute('data-legal-nav', heading.id);
        if (index === 0) link.setAttribute('aria-current', 'true');
        link.innerHTML =
          '<span class="snaiferr-legal__nav-num">' +
          pad(index + 1) +
          '</span><span class="snaiferr-legal__nav-sep" aria-hidden="true">—</span><span class="snaiferr-legal__nav-label"></span>';
        link.querySelector('.snaiferr-legal__nav-label').textContent = navLabel(heading.textContent.trim());
        item.appendChild(link);
        list.appendChild(item);
        links.push(link);

        if (select) {
          const option = document.createElement('option');
          option.value = heading.id;
          option.textContent = pad(index + 1) + ' — ' + navLabel(heading.textContent.trim());
          select.appendChild(option);
        }
      });

      const setActive = function (id) {
        links.forEach(function (link) {
          const on = link.getAttribute('data-legal-nav') === id;
          link.classList.toggle('is-active', on);
          if (on) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        if (select && select.value !== id) select.value = id;
      };

      const scrollToHeading = function (id) {
        const target = body.querySelector('#' + CSS.escape(id));
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      links.forEach(function (link) {
        link.addEventListener('click', function (event) {
          const id = link.getAttribute('data-legal-nav');
          event.preventDefault();
          if (history.replaceState) history.replaceState(null, '', '#' + id);
          setActive(id);
          scrollToHeading(id);
        });
      });

      if (select) {
        select.addEventListener('change', function () {
          if (history.replaceState) history.replaceState(null, '', '#' + select.value);
          setActive(select.value);
          scrollToHeading(select.value);
        });
      }

      const syncActive = function () {
        const probe = headerOffset();
        let current = headings[0];
        headings.forEach(function (heading) {
          if (heading.getBoundingClientRect().top <= probe + 8) current = heading;
        });
        if (current) setActive(current.id);
      };

      let ticking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            syncActive();
            ticking = false;
          });
        },
        { passive: true }
      );

      syncActive();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
